<template>
        <auftrag v-if="showAuftrag"
                 :show-loader="showLoader"
                 :hide-loader="hideLoader"
                 :on-attachment="onAttachment"
                 :on-file-clicked="onFileClicked"
                 :on-file-ok="onFileOk"
                 :response-error="responseError"
                 :show-finish="showFinish"
                 ref="auftrag"
        ></auftrag>
    <anfrage v-else-if="showAnfrage"
             :show-loader="showLoader"
             :hide-loader="hideLoader"
             :on-attachment="onAttachment"
             :on-file-clicked="onFileClicked"
             :on-file-ok="onFileOk"
             :response-error="responseError"
             ref="anfrage"
    ></anfrage>
    <aufgabe v-else-if="showAufgabe"
             :show-loader="showLoader"
             :hide-loader="hideLoader"
             :on-attachment="onAttachment"
             :on-file-clicked="onFileClicked"
             :on-file-ok="onFileOk"
             :response-error="responseError"
             ref="aufgabe"
    ></aufgabe>
  <aufgabe_offen v-else-if="showAufgabeOffen"
           :show-loader="showLoader"
           :hide-loader="hideLoader"
           :on-attachment="onAttachment"
           :on-file-clicked="onFileClicked"
           :on-file-ok="onFileOk"
           :response-error="responseError"
           ref="aufgabe_offen"
  ></aufgabe_offen>
  <aufgabe_in_bearbeitung v-else-if="showAufgabeInBearbeitung"
                 :show-loader="showLoader"
                 :hide-loader="hideLoader"
                 :on-attachment="onAttachment"
                 :on-file-clicked="onFileClicked"
                 :on-file-ok="onFileOk"
                 :response-error="responseError"
                 ref="aufgabe_in_bearbeitung"
  ></aufgabe_in_bearbeitung>
  <aufgabe_fertig v-else-if="showAufgabeFertig"
                          :show-loader="showLoader"
                          :hide-loader="hideLoader"
                          :on-attachment="onAttachment"
                          :on-file-clicked="onFileClicked"
                          :on-file-ok="onFileOk"
                          :response-error="responseError"
                          ref="aufgabe_fertig"
  ></aufgabe_fertig>
  <aufgabe_abgelehnt v-else-if="showAufgabeAbgelehnt"
                  :show-loader="showLoader"
                  :hide-loader="hideLoader"
                  :on-attachment="onAttachment"
                  :on-file-clicked="onFileClicked"
                  :on-file-ok="onFileOk"
                  :response-error="responseError"
                  ref="aufgabe_abgelehnt"
  ></aufgabe_abgelehnt>
  <auftrag_bauhof v-else-if="showAuftragBauhof"
                     :show-loader="showLoader"
                     :hide-loader="hideLoader"
                     :on-attachment="onAttachment"
                     :on-file-clicked="onFileClicked"
                     :on-file-ok="onFileOk"
                     :response-error="responseError"
                     ref="auftrag_bauhof"
  ></auftrag_bauhof>
  <auftrag_general_tour v-else-if="showAuftragGeneralTour"
                  :show-loader="showLoader"
                  :hide-loader="hideLoader"
                  :on-attachment="onAttachment"
                  :on-file-clicked="onFileClicked"
                  :on-file-ok="onFileOk"
                  :response-error="responseError"
                  ref="auftrag_general_tour"
  ></auftrag_general_tour>
  <auftrag_bauhof_offen v-else-if="showAuftragBauhofOffen"
                  :show-loader="showLoader"
                  :hide-loader="hideLoader"
                  :on-attachment="onAttachment"
                  :on-file-clicked="onFileClicked"
                  :on-file-ok="onFileOk"
                  :response-error="responseError"
                  ref="auftrag_bauhof_offen"
  ></auftrag_bauhof_offen>
  <planning-list v-else-if="showPlanningList"
                        :show-loader="showLoader"
                        :hide-loader="hideLoader"
                        :response-error="responseError"
                        ref="planning_list"
  ></planning-list>
</template>

<script>
    import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
    import {arrayBufferToBase64, decryptFile} from "../../../shared/crypto";
    import auftrag from "./auftrag"
    import anfrage from "./anfrage.vue"
    import aufgabe from "./aufgabe"
    import aufgabe_offen from "./aufgabe_offen.vue"
    import aufgabe_in_bearbeitung from "./aufgabe_in_bearbeitung.vue"
    import aufgabe_fertig from "./aufgabe_fertig.vue"
    import aufgabe_abgelehnt from "./aufgabe_abgelehnt.vue"
    import auftrag_bauhof from "./auftrag_bauhof.vue"
    import auftrag_general_tour from "./auftrag_general_tour.vue"
    import auftrag_bauhof_offen from "./auftrag_bauhof_offen.vue"
    import {signIn} from "@/shared/firebase";
    import PlanningList from "@/views/planning_lists/PlanningList.vue";

    export default {
        name: "AuftragRouter",
        components: {
          PlanningList, 'auftrag':auftrag, "anfrage": anfrage, "aufgabe": aufgabe, aufgabe_offen,
          aufgabe_in_bearbeitung, aufgabe_fertig, aufgabe_abgelehnt, auftrag_bauhof, auftrag_bauhof_offen, auftrag_general_tour},
        data: () => {
            return {
              isBauhof: false,
              loader: undefined,
                filename: "",
                showAuftrag: false,
                showAnfrage: false,
                showAufgabe: false,
                showAufgabeOffen: false,
                showAufgabeInBearbeitung: false,
              showAufgabeFertig: false,
              showAuftragBauhof: false,
              showAuftragBauhofOffen: false,
              showPlanningList: false,
                forceAnfrage: false,
              showAufgabeAbgelehnt: false,
              showFinish: false,
              showAuftragGeneralTour: false,
            }
            },
        created() {
          if (this.$cookies.isKey("ps_customer_number")) {
            this.showFinish = this.$cookies.get("ps_customer_number") === "1883538";
          }
            if (this.$route.query.force_anfrage === "true") {
                this.forceAnfrage = true;
            }
          this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
          this.showLoader();
            this.$http.get(
                Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
            ).then(this.handleDataOk, this.responseError)
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.$forceUpdate();
            this.showAnfrage = false;
            this.showAufgabe = false;
            this.showAuftrag = false;
            this.showAufgabeOffen= false;
            this.showAufgabeInBearbeitung = false;
            this.showAufgabeFertig = false;
            this.showAuftragBauhof = false;
            this.showAuftragBauhofOffen = false;
            this.forceAnfrage = false;
            if (this.$route.query.force_anfrage === "true") {
                this.forceAnfrage = true;
            }
            this.showLoader();
            this.$http.get(
                Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
            ).then(this.handleDataOk, this.responseError)
        },
        methods: {
            onFileClicked(message) {
                if (sessionStorage.getItem("aes") !== null) {
                    this.showLoader();
                    this.filename = message.data.file.name;
                    this.$http.get(
                        Server_URL + '/auftragsbuch/data/file_message/' + message.id + "?file_name=" + encodeURIComponent(message.data.file.name), {responseType: 'blob'}
                    ).then(this.onFileOk, this.responseError)

                } else {
                    window.open(Server_URL + '/auftragsbuch/data/file_message/' + message.id + "?file_name=" + encodeURIComponent(message.data.file.name), "_blank")
                }
            },
            onFileOk(response) {
                response.blob().then(blob => {
                    blob.arrayBuffer().then(binary => {
                        decryptFile(sessionStorage.getItem("aes"), new Uint8Array(binary)).then(res => {
                            this.hideLoader();
                            if (!this.isBauhof) {
                              const b = new Blob([res], {type: blob.type});
                              b.name = this.filename;
                              const blobUrl = URL.createObjectURL(b);
                              window.open(blobUrl, '_blank');
                            } else {
                              try {
                                windowsFileService.onFile(
                                    arrayBufferToBase64(res),
                                  this.filename,
                                  blob.type
                                ).then(r => {
                                  if (r && !r.Success) {
                                    console.log(r)
                                  }
                                }).catch(e => {
                                  console.log(e)
                                });
                              } catch (e) {
                                console.log(e);
                              }
                            }

                        }).catch(err => {
                            if(!this.isBauhof) {
                              this.hideLoader();
                              const blobUrl = URL.createObjectURL(blob);
                              window.open(blobUrl, '_blank');
                            } else {
                              try {
                                windowsFileService.onFile(
                                  arrayBufferToBase64(binary),
                                  this.filename,
                                  blob.type
                                ).then(r => {
                                  if (r && !r.Success) {
                                    console.log(r)
                                  }
                                }).catch(e => {
                                  console.log(e)
                                });
                              } catch (e) {
                                console.log(e);
                              }
                            }
                        })
                    })
                });
            },
            onAttachment(filename, data_id, filetype) {
                if (sessionStorage.getItem("aes") !== null) {
                    this.showLoader();
                    this.filename = filename;
                    this.$http.get(
                        Server_URL + '/auftragsbuch/upload/file/' + data_id + "?file_name=" + encodeURIComponent(filename) + "&file_type=" + filetype, {responseType: 'blob'}
                    ).then(this.onFileOk, this.responseError)

                } else {
                    window.open(Server_URL + '/auftragsbuch/upload/file/' + data_id + "?file_name=" + encodeURIComponent(filename) + "&file_type=" + filetype, "_blank")
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_Login;
                }
            },
            showLoader() {
                this.hideLoader();
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            handleDataOk(response) {
                if (response.status === 200 && response.body.status === "ok") {
                    let data = response.body.data;
                    /*if (data.data.art === 'LS') {
                      this.showPlanningList = true;
                      this.$nextTick(() => {
                        this.$refs.planning_list.responseOkFetch(response);
                      });
                    }
                    else*/
                     if (data.data.art === "AU" && data.data.offen === 0 && data.data.a_nehmer !== "Bauhof" && data.data.a_nehmer_user === "") {

                      // todo check, but maybe weiterleiten
                      if (data.is_bauhof && data.can_accept_bauhof) {
                        this.showAuftragBauhofOffen = true;
                        this.$nextTick(() => {
                          this.$refs.auftrag_bauhof_offen.responseOkFetch(response);
                        });
                      } else {
                        this.showAufgabeOffen = true;
                        this.$nextTick(() => {
                          this.$refs.aufgabe_offen.responseOkFetch(response);
                        });
                      }
                    } else if (data.data.art === "AU" && data.data.offen === 0 && data.data.a_nehmer !== "Bauhof" && data.data.a_nehmer_user !== "") {
                      // todo check, but maybe weiterleiten
                      this.showAufgabeInBearbeitung = true;
                      this.$nextTick(() => {
                        this.$refs.aufgabe_in_bearbeitung.responseOkFetch(response);
                      });
                    } else if (data.data.art === "DC") {
                      // todo check
                      this.showAufgabeAbgelehnt = true;
                      this.$nextTick(() => {
                        this.$refs.aufgabe_abgelehnt.responseOkFetch(response);
                      });
                    } else if (data.data.art === "G") {
                       this.showAuftragGeneralTour = true;
                       this.$nextTick(() => {
                         this.$refs.auftrag_general_tour.responseOkFetch(response);
                       });
                     } else if (data.data.id !== "" && data.data.a_nehmer === "Bauhof" && data.data.art !== "SO" && data.is_bauhof) {
                      if (data.data.offen === 0 && data.data.a_nehmer_user === "") {
                        this.showAuftragBauhofOffen = true;
                        this.$nextTick(() => {
                          this.$refs.auftrag_bauhof_offen.responseOkFetch(response);
                        });
                      } else {
                        this.showAuftragBauhof = true;
                        this.$nextTick(() => {
                          this.$refs.auftrag_bauhof.responseOkFetch(response);
                        });
                      }
                    } else if (data.data.id !== "" && (data.data.a_nehmer === "Bauhof" || data.data.art === "SO")) {
                        this.showAuftrag = true;
                        this.$nextTick(() => {
                            this.$refs.auftrag.responseOkFetch(response);
                        });
                    } else if (data.data.art === "AU" && data.data.offen === 1 && data.data.a_nehmer !== "Bauhof") {
                      this.showAufgabeFertig = true;
                      this.$nextTick(() => {
                        this.$refs.aufgabe_fertig.responseOkFetch(response);
                      });
                    } else if (data.data.id !== "" && !this.forceAnfrage) {
                        this.showAufgabe = true;
                        this.$nextTick(() => {
                            this.$refs.aufgabe.responseOkFetch(response);
                        });
                    } else {
                        this.showAnfrage = true;
                        this.$nextTick(() => {
                            this.$refs.anfrage.responseOkFetch(response);
                        });
                    }

                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            }
        }
    }
</script>

<style scoped>

</style>
